import React from "react";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";

import JwtClient from "./JwtClient";
import Logout, {FormatDate, FormatManifestNumber} from "./utils";
import Alert from "./Alert";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";

// TODO: sort manifests by created_at
export default class ManifestList extends React.Component {
    constructor(props) {
        super(props);
        this.manifestsRef = React.createRef();
        this.state = {
            alert: '',
            manifests: [],
            currentPage: 1,
            pagesTotal: 0,
            loading: true,
            refOrMAWB: props.match.params.refOrMAWB,
        };


    }

    render() {
        if (!!this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }

        if (this.state.loading) {
            return (<div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )
        }
        if (!this.state.manifests) {
            return null;
        }
        if (this.state.manifests.length === 0) {
            return null;
        }

        return (
            <Container>
                <Row className="mx-0">
                    <h4 ref={this.manifestsRef} className="mt-4">Manifests</h4>
                </Row>
                <Form inline onSubmit={e => {
                    e.preventDefault();
                    this.props.history.push('/' + this.state.refOrMAWB);
                    this.getManifests(1, this.state.refOrMAWB);
                }} className="mb-2">
                    <FormControl
                        type="text"
                        placeholder="Ref or MAWB"
                        className="mr-2"
                        onChange={e => {
                            this.setState({refOrMAWB: e.target.value})
                        }}
                        value={this.state.refOrMAWB}
                    />
                    <Button variant="outline-success" type="submit"
                            disabled={this.state.refOrMAWB === '' || !this.state.refOrMAWB || (this.state.refOrMAWB && this.state.refOrMAWB.length <= 3)}>Filter</Button>
                </Form>

                <Table>
                    <thead>
                    <tr>
                        <th>Ref</th>
                        <th>MAWB</th>
                        <th>Airports</th>
                        <th>Flight</th>
                        <th>Broker</th>
                        <th title="Green: left customs">Event</th>
                        <th>Departure</th>
                        <th>Packages</th>
                        <th>#</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.manifests.map((m, index) => {
                            let event = m.last_tracking_event_description ? m.last_tracking_event_description : '';
                            return (
                                <tr key={index}>
                                    <td>{m.velox_reference_number}</td>
                                    <td><a href={"manifests/" + m.id}>{m.mawb}</a></td>
                                    <td>{m.origin_iata_airport_code} - {m.destination_iata_airport_code}</td>
                                    <td>{m.flight_number}</td>
                                    <td>{m.customs_clearance_broker}</td>
                                    <td>{event === 'left customs' ?
                                        <span className="text-success">{event}</span> : event}</td>
                                    <td>{FormatDate(m.departure_date)}</td>
                                    <td>{m.packages_count}</td>
                                    <td>{FormatManifestNumber(m.manifest_number, m.user_id)}</td>
                                </tr>
                            );
                        })
                    }
                    </tbody>
                </Table>

                <ul className="pagination justify-content-center">
                    <li className={this.state.currentPage === 1 ? "page-item disabled" : "page-item"}>
                        <a className="page-link" href="#" onClick={(e) => {
                            e.preventDefault()
                            this.getManifests(this.state.currentPage - 1)
                        }}>
                            Previous
                        </a>
                    </li>
                    <li className="page-item active"><span className="page-link">{this.state.currentPage}</span>
                    </li>

                    <li className={this.state.currentPage === this.state.pagesTotal ? "page-item disabled" : "page-item"}>
                        <a className="page-link"
                           href="#" onClick={(e) => {
                            e.preventDefault()
                            this.getManifests(this.state.currentPage + 1)
                        }}>
                            Next
                        </a>
                    </li>
                </ul>

            </Container>
        )
    }

    componentDidMount() {
        this.getManifests(1, this.props.match.params.refOrMAWB);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.currentPage !== this.state.currentPage) {
            this.manifestsRef.current.scrollIntoView(true);
        }
    }

    getManifests(page, refOrMAWB) {
        this.setState({loading: true})
        let url = `/api/v1/admin/manifests?page=${page}`;
        if (refOrMAWB) {
            url += `&q=${refOrMAWB}`
        }
        JwtClient.get(url)
            .then(response => {
                const data = response.data;
                this.setState({
                    manifests: data.manifests,
                    pagesTotal: data.pages_total,
                });
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        Logout();
                    }
                    this.setState({alert: 'Error on fetching manifests, status: ' + error.response.status});
                } else {
                    this.setState({alert: JSON.stringify(error)});
                }
            })
            .finally(() => {
                this.setState({loading: false, currentPage: page})
            })
    }
}